<template>
  <BSidebar
    :id="id"
    :visible="visible"
    class="bg-white"
    backdrop-variant="dark"
    backdrop
    no-close-on-backdrop
    right
    shadow
    width="620px"
    aria-hidden="false"
  >
    <template #header>
      <div class="d-flex align-items-center w-100 p-[.75rem] gap-[1.25rem] border-bottom">
        <BButton
          id="filter"
          size="sm"
          variant="primary"
          class="!p-[.6rem]"
          @click="$emit('on-close')"
        >
          <span
            class="k-arrow-left-3 text-[16px]"
          />
        </BButton>

        <h5 class="text-[#333333] text-2xl font-semibold mb-0">
          Detail Top Up Whitelisted
        </h5>
      </div>
    </template>
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        class="!p-[1rem_1.75rem]"
        :class="{ 'invisible': loading }"
      >
        <p
          :class="[
            'p-[.5rem] text-center !border-[solid] !border-[1px] rounded-xl mb-[1.5rem]',
            transaction.status === 'success' ? 'bg-[#E6F6EB] !border-[#D6F1DF] text-[#30A46C]' : '',
            transaction.status === 'process' ? 'bg-[#FFD0B5] !border-[#FFB088] text-[#E55514]' : '',
            transaction.status === 'processing' ? 'bg-[#F0F0F0] !border-[#E8E8E8] text-[#8D8D8D]' : '',
            transaction.status === 'transferred' ? 'bg-[#E6F4FE] !border-[#D5EFFF] text-[#0090FF]' : '',
            isFailedStatus ? 'bg-[#FEEBEC] !border-[#FFDBDC] text-[#DC2626]' : '',
          ]"
        >{{ transactionStatus[transaction.status] }}</p>
        <div class="flex justify-between align-items-center mb-[.5rem]">
          <p class="text-black text-bold mb-0">
            Detail Transaksi Partner
          </p>
          <div class="flex align-items-center gap-[.25rem]">
            <img
              :src="platformIcon"
              :alt="`${transaction.platform_name}-${transaction.ad_account_type}`"
              width="24"
              height="24"
            >
            <img
              v-if="transaction.ad_account_type === 'cpas'"
              src="https://storage.googleapis.com/komerce/komads-meta/shopee.svg"
              :alt="`${transaction.platform_name}-${transaction.ad_account_type}`"
              width="24"
              height="24"
            >
            <span class="text-black text-bold capitalize">{{ transaction.platform_name }} {{ transaction.ad_account_type || 'whitelist' }}</span>
          </div>
        </div>
        <div class="p-[.75rem] border rounded-xl mb-[1.25rem] detail-transaction">
          <p class="mt-[.75rem]">
            <span>Tanggal Diproses</span>
            <span>: {{ transaction.updated_at ? FULL_DATE_TIME_WITH_WIB(transaction.updated_at) : '-' }}</span>
          </p>
          <p>
            <span>Tanggal Top Up</span>
            <span>: {{ transaction.created_at ? FULL_DATE_TIME_WITH_WIB(transaction.created_at) : '-' }}</span>
          </p>
          <p>
            <span>ID Transaksi</span>
            <span>: {{ transaction.transaction_id }}</span>
          </p>
          <p>
            <span>Email Akun</span>
            <span>: {{ transaction.partner_email }}</span>
          </p>
          <p v-if="transaction.gmail">
            <span>Email Akun Iklan</span>
            <span>: {{ transaction.gmail }}</span>
          </p>
          <p>
            <span>Akun WL Tujuan</span>
            <span>: {{ transaction.whitelist_account_name }}</span>
          </p>
          <p v-if="isMetaPlatform">
            <span>ID Ad Account</span>
            <span>: {{ transaction.ad_account_id }}</span>
          </p>
          <p v-if="isMetaPlatform">
            <span>Bussiness Manager</span>
            <span>: {{ transaction.bm_id }}</span>
          </p>
          <p>
            <span>Nominal Top Up</span>
            <span>: {{ IDR(transaction.amount_topup) }}</span>
          </p>
          <div>
            <span
              v-if="transaction.fee_topup"
              class="dashed-line mb-[.75rem]"
            />
            <p v-if="transaction.fee_topup">
              <span>Top Up Fee ({{ transaction.fee_topup }}%)</span>
            </p>
            <ul>
              <li v-if="transaction.amount_fee">
                <p>
                  <span>Fee</span>
                  <span>: {{ IDR(transaction.amount_fee) }}</span>
                </p>
              </li>
              <li v-if="transaction.amount_tax">
                <p>
                  <span>PPN</span>
                  <span>: {{ IDR(transaction.amount_tax) }}</span>
                </p>
              </li>
            </ul>
            <span class="dashed-line mb-[.75rem]" />
          </div>
          <p>
            <span class="!text-black !font-semibold">Total Dibayarkan</span>
            <span class="text-primary !font-semibold">: {{ IDR(transaction.amount_total) }}</span>
          </p>
        </div>
        <div>
          <div class="flex justify-between align-items-center mb-[.5rem]">
            <p class="text-black text-bold mb-0">
              {{ isFailedStatus ? 'Detail Gagal Top Up' : 'Detail Transfer Provider' }}
            </p>
            <BButton
              v-if="transactionActionVisibility(transactionAction.providerLabel)"
              variant="outline-secondary"
              size="sm"
              class="!flex !items-center !gap-2 !text-black"
              @click="transactionAction.providerAction"
            >
              <i
                v-if="transactionAction.providerIcon"
                :class="transactionAction.providerIcon"
                class="text-[18px]"
              />
              <span>{{ transactionAction.providerLabel }}</span>
            </BButton>
          </div>
          <div
            v-if="isFailedStatus"
            class="p-[.75rem] border rounded-xl mb-[1.25rem]"
          >
            <p class="text-[#828282]">
              Catatan:
            </p>
            <p class="break-words">
              {{ transaction.notes }}
            </p>
          </div>
          <div
            v-else
            class="p-[.75rem] border rounded-xl mb-[.5rem] detail-transaction"
          >
            <p>
              <span>Nama Akun WL</span>
              <span>: {{ transaction.whitelist_account_name }}</span>
            </p>
            <p>
              <span>Nominal Top Up</span>
              <span>: {{ IDR(transactionDisbursementProvider.amount_topup) }}</span>
            </p>
            <p v-if="transactionDisbursementProvider.fee_topup">
              <span>Top Up Fee ({{ transactionDisbursementProvider.fee_topup }}%)</span>
              <span>: {{ IDR(transactionDisbursementProvider.provider_fee) }}</span>
            </p>
            <p v-if="transactionDisbursementProvider.unique_code">
              <span class="break-words">3 Digit Terakhir<br>(Kode Unik)</span>
              <span>: {{ transactionDisbursementProvider.unique_code }}</span>
            </p>
            <p>
              <span class="!text-black !font-semibold">Total Dibayarkan</span>
              <span class="text-primary !font-semibold">: {{ IDR(transactionDisbursementProvider.amount_total) }}</span>
            </p>
          </div>
        </div>
        <div class="flex items-between gap-[1rem] mt-[1rem] drawer-action">
          <BButton
            size="md"
            variant="primary"
            block
            class="m-0"
            :class="{ 'cursor-not-allowed': isDisableConfirmAction}"
            :disabled="isDisableConfirmAction"
            @click.prevent="transactionAction.confirmAction"
          >
            {{ transactionAction.confirmLabel }}
          </BButton>
          <BButton
            size="md"
            variant="light"
            block
            class="m-0"
            @click="$emit('on-close')"
          >
            Batalkan
          </BButton>
        </div>
        <p
          v-if="isFailedStatus"
          class="text-[#737373] text-center mt-2"
        >
          Gagal Top Up Ulang? <BButton
            variant="link"
            class="!p-0 text-primary"
            @click="$emit('on-manual-process')"
          >
            Proses Manual
          </BButton>
        </p>
      </div>
    </BOverlay>
  </BSidebar>
</template>

<style scoped>
.detail-transaction p {
  margin-bottom: .75rem !important;
  display: flex;
  align-items: start;
}
.detail-transaction p > :nth-child(1) {
  flex: 0 0 180px;
  text-align: left;
  color: #828282;
}
.detail-transaction p > :nth-child(2) {
  flex: 1;
  text-indent: -5px;
}
.dashed-line {
  display: block;
  height: 1.5px;
  background-image: repeating-linear-gradient(to right,
        #E5E5E5 0,
        #E5E5E5 12px,
        transparent 12px,
        transparent 24px) !important;
}
.btn-outline-secondary {
  border: 1px solid #E5E5E5 !important;
}
.drawer-action > .btn-light {
  background-color: #e4e4e4 !important;
}
.drawer-action > .btn-light:hover {
  background-color: #E5E5E5 !important;
}
</style>

<script>
import { IDR } from '@/libs/currency'
import { FULL_DATE_TIME_WITH_WIB } from '@/libs/filterDate'

export default {
  props: {
    id: {
      type: String,
      default: 'detail-drawer',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    platformIcon: {
      type: String,
      default: '#',
    },
    transaction: {
      type: Object,
      default: () => ({}),
    },
    transactionStatus: {
      type: Object,
      default: () => ({}),
    },
    transactionAction: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    transactionDisbursementProvider() {
      return this.transaction.disbursement_provider || {}
    },
    isDisableConfirmAction() {
      return ['processing', 'success'].includes(this.transaction.status) || (this.transaction.platform_name === 'meta' && !['failed', 'transferred'].includes(this.transaction.status))
    },
    isMetaPlatform() {
      return this.transaction.platform_name === 'meta'
    },
    isFailedStatus() {
      return this.transaction.status === 'failed'
    },
  },
  methods: {
    IDR,
    FULL_DATE_TIME_WITH_WIB,
    transactionActionVisibility(label) {
      if (label === 'Download Invoice') {
        return this.transaction.is_provider_disbursement && !(this.transaction.is_first_time_topup || this.transaction.is_first_time_subscription)
      }
      if (label === 'Cek Status') {
        if (this.isMetaPlatform) return this.transaction.status !== 'processing'
      }
      if (label === 'Salin Detail Transaksi') {
        if (this.isMetaPlatform) return this.transaction.status === 'success'
      }
      return true
    },
  },
}
</script>
